import { set, has } from 'lodash-es';

export default {
  inject: ['fieldIsPresent'],

  props: {
    modelValue: {
      type: Object,
      required: true,
    },
    step: {
      type: Number,
      required: true,
    },
    stepFields: {
      type: Array,
      required: true,
    },
  },

  emits: ['changeStep', 'update:modelValue'],

  computed: {
    fields: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit('update:modelValue', value);
      },
    },
  },

  watch: {
    fields: {
      handler() {
        this.stepFields.forEach((field) => {
          if (!has(this.fields, [field, 'scope'])) {
            set(this.fields, [field, 'scope'], `step-${this.step}`);
          }
        });
      },
      immediate: true,
    },
  },
};
